import { ref, computed, inject, watch, toValue } from 'vue'
import { format } from 'date-fns'
import { omit } from 'lodash-es'
import { syncRef } from '@vueuse/core'
import { useApi } from '@provise/composables/api'
import { transformer } from '@provise/lib/transformer'
import { useMessageStack } from '@provise/stores/messagestack'

const model = ref({})
const trnsf = ref({})
const sentTransfer = ref({})

syncRef(model, sentTransfer, { direction: 'ltr' })

const useTransfer = () => {
  const complaint = inject('complaint', () => ref({}), true)
  const { model: transfers, refresh: fetchTransfers } = useApi({
    data: [],
    url: computed(() => `complaints/${complaint.value.id}/transfers`),
    pick: d => d.data || [],
  })
  const { push: notify } = useMessageStack()
  const { refresh: fetchTransfer } = useApi({
    data: {},
    model,
    url: computed(() => {
      const segments = ['complaints', complaint.value.id, 'transfers']
      if (model.value?.id) {
        segments.push(model.value.id)
      }
      return segments.join('/')
    }),
    method: 'put',
    transform: d =>
      omit(
        transformer(
          [
            ['author', 'id'],
            ['receiver', 'id'],
            ['status', 'id'],
            ['department', 'id'],
            ['courier', 'id'],
            ['uploads','ids'],
          ],
          true
        )(d),
        'author',
        'deleted',
        'status',
        'id',
        'date_created'
      ),
  })
  const { refresh: approveTransfer } = useApi({
    url: computed(() => `complaints/${complaint.value.id}/transfers/${model.value.id}/approve`),
    model,
  })
  const { refresh: declineTransfer } = useApi({
    url: computed(() => `complaints/${complaint.value.id}/transfers/${model.value.id}/decline`),
    model,
  })
  const { refresh: sendTransfer, error: sendError } = useApi({
    url: computed(() => `complaints/${complaint.value.id}/transfers/${model.value.id}/send`),
    model: sentTransfer,
  })

  watch(
    transfers,
    tr => {
      let res
      if (tr?.length) {
        res = [...tr]
        res.sort((a, b) => {
          let d = a.date_created.valueOf() - b.date_created.valueOf()

          return d == 0 ? 0 : (d >> -1) | 1 // 1/-1
        })
        res = res[0]
      }

      if (res) {
        res.date_created_f = format(res.date_created, 'dd.MM.yy')
      }
      trnsf.value = res
    },
    { immediate: true }
  )

  async function approveTransferWrapper() {
    const modelValue = toValue(model)
    if (['transfer_started', 'prepare'].includes(modelValue.status?.key)) {
      await sendTransfer()
      if (sendError.value || sentTransfer.value.error != 0) {
        let errMessage = 'Произошла ошибка. Сообщение не отправлено.'
        if (sentTransfer.value.error) {
          errMessage = sentTransfer.value.error_description
        }
        notify({ type: 'error', message: errMessage })
        return
      }
      notify('Сообщение отправлено')
    }
    return approveTransfer()
  }

  return {
    fetchTransfers,
    transfers,
    fetchTransfer,
    transfer: model,
    firstTransfer: trnsf,
    approveTransfer: approveTransferWrapper,
    declineTransfer,
  }
}

export { useTransfer }
